export enum ApplicationSettingsPage {
  SETTINGS = undefined,
  NOTIFICATION_PROFILES = 'notification-profiles',
  PERMISSION_PROFILES = 'permission-profiles',
}

export const ApplicationSettingsPageUrl = {
  undefined: ApplicationSettingsPage.SETTINGS,
  'notification-profiles': ApplicationSettingsPage.NOTIFICATION_PROFILES,
  'permission-profiles': ApplicationSettingsPage.PERMISSION_PROFILES,
}
